export function formatMoney(value) {
  return new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    maximumFractionDigits: 0,
  }).format(Number(value || 0));
}

export function toDateInput(value) {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  return date.toISOString().slice(0, 10);
}

export function todayInput() {
  const now = new Date();
  const local = new Date(now.getTime() - now.getTimezoneOffset() * 60000);
  return local.toISOString().slice(0, 10);
}

export function statusTone(status) {
  if (["Paid", "Approved", "Active"].includes(status)) return "success";
  if (["Pending", "Draft", "Sent", "On Hold"].includes(status)) return "warn";
  if (["Overdue", "Rejected", "Cancelled", "Closed", "Inactive"].includes(status)) return "danger";
  return "neutral";
}

export function FinanceBadge({ status }) {
  return <span className={`finance-badge ${statusTone(status)}`}>{status}</span>;
}
